/*
 * @Author: xiongpin.yxp
 * @Description: 常量
 * @Date: 2021-01-27 16:34:28
 * @LastEditTime: 2021-02-01 21:29:17
 * @LastEditors: xiongpin.yxp
 * @FilePath: /aliwx-page-def-midway/web/constants/index.js
 * @妈祖保佑
 */

export const PLATFORM_MAP = {
  BOOKTOUCH: '0',
  SHUQI_IOS: '1',
  SHUQI_AND: '2',
  SHUQI_HARMONY: '156',
  UC_IOS: '3',
  UC_AND: '4',
  HUAWEI: '100',
  QUARK_AND: '113',
  QUARK_IOS: '114',
  QUARK_HARMONY: '157',
  LITE_AND: '115',
  LITE_IOS: '116',
};

export const UC_PLATFORMS = [
  PLATFORM_MAP.UC_IOS,
  PLATFORM_MAP.UC_AND,
];

export const QUARK_PLATFORMS = [
  PLATFORM_MAP.QUARK_IOS,
  PLATFORM_MAP.QUARK_AND,
  PLATFORM_MAP.QUARK_HARMONY,
];

// 需要再客户端注入user_id的平台
export const INJECT_USER_ID_PLATFORMS = [
  ...UC_PLATFORMS,
  ...QUARK_PLATFORMS,
];

// uc\quark平台
export const UC_QUARK_PLATFORMS = [
  ...UC_PLATFORMS,
  ...QUARK_PLATFORMS,
];

export const INNER_PLATFORMS = [
  PLATFORM_MAP.SHUQI_IOS,
  PLATFORM_MAP.SHUQI_AND,
  PLATFORM_MAP.LITE_IOS,
  PLATFORM_MAP.LITE_AND,
  PLATFORM_MAP.HUAWEI,
];

export const TOURIST_USER_ID = 8000000;
